const initState = {
    departments: [],
    all_departments: [],
    department_name: null,
    department_id: null,
    department: null,
    policies: [],
    actions: [],
    finding_data: [],
    actions_data: [],
    department_dashboard_data: null,
    activeDepartmentId: null,
    notifications_settings: [],
};

const departmentReducer = (state = initState, action) => {

    switch (action.type) {
        case "NOTIFICATIONS_SETTINGS":
            return {
                ...state,
                notifications_settings: action.notifications,
            };

        case "SET_ACTIVE_DEPARTMENT":
            console.log("Called", action.department_id)
            return {
                ...state,
                activeDepartmentId: action.department_id,
            };

        case "OPEN_DEPARTMENT_DASHBOARD": 
            return {
                ...state,
                department_dashboard_data: action.department_id,
            };

        case "RESET_DEPARTMENT_DASHBOARD":
            return {
                ...state,
                department_dashboard_data: null,
            };

        case "ACTIONS":
            return {
                ...state,
                actions: action.actions,
            };
        case "ACTIONS_DATA":
            return {
                ...state,
                actions_data: action.actions,
            };
        case "FINDINGS_DATA":
            return {
                ...state,
                finding_data: action.findings,
            };
        case "POLICIES":
            console.log("Here")
            return {
                ...state,
                departments: action.departments,
            };

        case "UPDATE_DEPARTMENT":
            return {
                ...state,
                department: action.department,
            };
        case "ALL_DEPARTMENTS":
            return {
                ...state,
                all_departments: action.all_departments,
            };


        case "RESET_DEPARTMENT":
            return {
                ...state,
                department_id: null,
            };
        case "DEPARTMENT_NAME":
            return {
                ...state,
                department_name: action.department_name,
            };

        case "OPEN_DEPARTMENT":
            console.log("Opening ",action.department_id)
            return {
                ...state,
                department_id: action.department_id,
            };

        case "DEPARTMENTS":
            return {
                ...state,
                departments: action.departments,
            };

        case "RESET_NEWLYCREATED_DEPARTMENT_ID":
            return {
                ...state,
                newlycreatedDepartmentId: null,
            };

        case "DEPARTMENT_CREATED":
            return {
                ...state,
                departments: action.departments,
                newlycreatedDepartmentId: action.newlycreatedDepartmentId,
            };

        default:
            return state;
    }
};

export default departmentReducer;
